export const dIntervalsGenerator = () => {
  let arr = ["00:00:00"];

  for (let i = 0; i < 47; ++i) {
    let str = arr[arr.length - 1].split(":"),
      int0 = parseInt(str[0]),
      int1 = parseInt(str[1]);

    if (int1 + 30 === 60) {
      str[0] = (int0 + 1).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      str[1] = "00";
    } else str[1] = (int1 + 30).toString();

    let time = str[0] + ":" + str[1] + ":00";

    arr.push(time);
  }

  return arr;
};
